import { render, staticRenderFns } from "./zbyg.vue?vue&type=template&id=7804a218"
import script from "./zbyg.vue?vue&type=script&lang=js"
export * from "./zbyg.vue?vue&type=script&lang=js"
import style0 from "./zbyg.vue?vue&type=style&index=0&id=7804a218&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports